export default {
  ANIMALS_ALLOWED: 'Можно с животными',
  WATER_METER: 'Счетчик воды',
  BALCONY: 'Балкон/лоджия',
  BATHHOUSE: 'Баня',
  BUILDING_TYPE: 'Тип дома',
  CANALIZATION: 'Канализация',
  CEILING_HEIGHT: 'Высота потолка',
  CHILDREN_ALLOWED: 'Можно с детьми',
  CONDITIONING: 'Кондиционер',
  CORNER: 'Угловая',
  DEADLINE: 'Срок сдачи',
  DETACHED_BUILDING: 'Отдельностоящее здание',
  ELECTRICITY: 'Электроснабжение',
  ELEVATOR: 'Лифт',
  FIRST_LINE: 'Первая линия',
  FLOOR: 'Этаж',
  FLOOR_COVERING: 'Покрытие пола',
  FLOOR_TOTAL: 'Кол-во этажей',
  FRIDGE: 'Холодильник',
  FURNITURE: 'Мебель',
  GARAGE: 'Гараж',
  GAS: 'Газоснабжение',
  HEATING: 'Отопления',
  INTERCOM: 'Домофон',
  INTERNET: 'Интернет',
  MATERIAL: 'Материал стен',
  NEW_BUILDING: 'Новостройка',
  NEW_HOUSE: 'Новый дом',
  NUMBER_OF_BEDS: 'Кол-во спальных мест',
  OUTBUILDINGS: 'Хоз. постройки',
  OUTER_DOOR_TYPE: 'Входная дверь',
  OWN_ENTRANCE: 'Отдельный вход',
  PARKING_TYPE: 'Парковка',
  PLANNING: 'Планировка',
  PROTECTED_PARKING: 'Охраняемая парковка',
  RENOVATION_BUILDING: 'Состояние дома',
  RENOVATION_TYPE: 'Состояние/ремонт',
  RENT_PERIOD: 'Период сдачи в аренду',
  RUBBISH_CHUTE: 'Мусоропровод',
  SANITARY: 'Санузел',
  SECURITY_PROTECTION: 'Охрана',
  SQUARE_HOUSE: 'Площадь дома',
  SQUARE_KITCHEN: 'Площадь кухни',
  SQUARE_LAND: 'Площадь участка',
  SQUARE_LIVING: 'Площадь жилая',
  SQUARE_TOTAL: 'Площадь общая',
  PERSON_COUNT: 'Количество человек',
  GENDER_PREFERENCE: 'Предпочтение к жильцам',
  TV: 'Телевизор',
  USAGE_CATEGORY: 'Категория использования',
  WASHING_MACHINE: 'Стиральная машина',
  WATER: 'Водоснабжение',
  WINDOW_TYPE: 'Материал окон',
  WINDOW_VIEW: 'Вид из окон',
  YEAR_OF_CONSTRUCTION: 'Год постройки',
  REPAIR_PIT: 'Смотровая яма',
  CELLAR: 'Погреб',
  SIZES: 'Размеры, м',
  DISTANCE_FROM_CITY: 'Удаленность от города',
  REFERENCE: 'Остановка или ориентир'
};



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/attributes.js